var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{ref:"player",attrs:{"controls":_vm.controls,"src":_vm.src}})
}
var staticRenderFns = []

export { render, staticRenderFns }